export const SET_UNASSIGNED_ESENSOR_DEVICES = 'device:setUnassignedEsensorDevices'
export const SET_INACTIVE_NETWORK_DEVICE = 'device:setInactiveNetworkDevice'
export const SET_FOR_APPROVAL_NETWORK_DEVICE = 'devcie:setForApprovalNetworkDevice'
export const SET_NETWORK_DEVICE_IMAGES = 'device:setNetworkDeviceImages'